export function numberNormalizer(n: number|string): number {
    return ('number' === typeof n) ? n : parseInt(n.replace(/[^0-9\-.]+/gi, '').trim());
}